import {styled} from '@linaria/react';
import React, {ComponentProps, FC} from 'react';
import {BlurryBackground} from '../../atoms/BlurryBackground/BlurryBackground';

/**
 * Ambient background list item. The `li` is the clipping frame — `overflow`
 * must live here (not on the blurred/scaled child), otherwise `filter` +
 * `transform` on BlurryBackground paint outside the ambient and make image
 * ambience read larger than solid-colour ones.
 */
export const BackgroundCard: FC<
  ComponentProps<typeof BlurryBackground> & {isActive: boolean}
> = ({isActive, className, ...props}) => {
  return (
    <Root
      data-active={isActive}
      data-testid="backgroundCard"
      className={className}
    >
      <StyledBlurryBackground {...props} />
    </Root>
  );
};

const Root = styled.li`
  position: absolute;
  inset: 0;
  overflow: hidden;
  /* clip-path reliably contains filter/blur ink overflow that escapes
     overflow:hidden alone in WebKit. No corner rounding here: the slider
     container owns it (square desktop slider vs rounded mobile ambient). */
  clip-path: inset(0);
`;

const StyledBlurryBackground = styled(BlurryBackground)`
  opacity: 0;
  transition: opacity 500ms ease-in-out 250ms;

  [data-active='true'] & {
    transition-delay: 0ms;
    opacity: 1;
  }
`;
